import { defineStore } from "pinia";
import { findNodeById } from "../utils";
const store_system_key = 'store_system'

export const SystemStore = defineStore(store_system_key, {
  state: () => ({
	page:1,//当前页数
	category_id:0, //搜索类目id
	categories:[],//详细类目数组结构
	total_categories:[], //全部类目,

	selected_file_category_id:0,//文件类目id
  }),
  actions: {
	update_current_page(page){
		this.page = page
	},
	update_all_categories(categories){
		this.total_categories = categories
	},
	change_category(cate_id){
		this.category_id = cate_id;
		this.categories = findNodeById(this.total_categories,cate_id)
	},
	update_file_category(cate_id){
		this.selected_file_category_id = cate_id
	}
    
  },
  getters: {
	getCurrentPage:(state) => state.page,
	getCategoryId:(state) => state.category_id,
	getTotalCategories:(state) => state.total_categories,
	getCategories:(state) => state.categories,
	getFileCateogryId:(state) => state.selected_file_category_id
  },
  persist: {
      enabled: true,
      strategies: [
        {
          key: 'system',
          storage: localStorage,
        },
      ],
    },
});

